import { render, staticRenderFns } from "./ServiceAbsencesTableContainer.vue?vue&type=template&id=9b1e3826&scoped=true&"
import script from "./ServiceAbsencesTableContainer.vue?vue&type=script&lang=js&"
export * from "./ServiceAbsencesTableContainer.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAbsencesTableContainer.vue?vue&type=style&index=0&id=9b1e3826&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1e3826",
  null
  
)

export default component.exports